import isProduction from './is-production';

// Auth-bridge allowlist for ?return_to= origins that may receive the JWT. Strict
// on prod (explicit list only — a prod JWT must never leak to an arbitrary
// origin); on dev also trust any *.eduki.info stage + localhost so the many
// ephemeral dev stages work without code edits. Changing PROD_TRUSTED_ORIGINS
// needs a deploy — keep it in sync with AI_STUDIO_BASE_URL
// (utils/ai-studio/ai-studio-url), whose default production relied on as of 2026-10.
// Entries are matched against URL.origin, so each one must be a bare origin —
// scheme + host [+ port], never a trailing slash or a path.
//
// AI-1703: AI Studio is moving from studio.eduki.com to adapt.eduki.com. BOTH
// stay listed for as long as the studio -> adapt redirect is live, because a
// bookmark or a cached return_to still carries the old origin. Dropping the old
// one early strands those users at the login screen with no signal anywhere:
// the browser never reaches Studio, so Studio's own monitoring stays silent.
// Remove studio.eduki.com only once that redirect is retired.
export const PROD_TRUSTED_ORIGINS: readonly string[] = [
    'https://adapt.eduki.com',
    'https://studio.eduki.com',
    'https://omnidoc.common.eduki.tech'
];

const isTrustedReturnToOrigin = (returnTo: string, isProd = isProduction()): boolean => {
    let url: URL;

    try {
        url = new URL(returnTo);
    } catch {
        return false;
    }

    if (PROD_TRUSTED_ORIGINS.includes(url.origin)) {
        return true;
    }

    if (isProd) {
        return false;
    }

    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
        return true;
    }

    return url.protocol === 'https:' && url.hostname.endsWith('.eduki.info');
};

export default isTrustedReturnToOrigin;
